module.exports = __webpack_public_path__ + "img/image.55936a79.png";